import React from 'react'
import Color from '../../../components/Field.Color'

import Card from './Card'
import Group from './Group'
import Item from './Group.Item'

function Component(
    {
        fieldLayout,
        disabled,

        select,
        onChange,
    }
)
{
    return (
        <Card title="โปรโมชั่น" >
            <Group>
                <Item>
                    <Color 
                        disabled={disabled}
                        layout={fieldLayout}
                        label="พื้นหลัง"
                        name="ribbon.bgColor"
                        alpha={false}
                        value={select('ribbon.bgColor')}
                        onChange={onChange}
                    />
                    
                    <Color 
                        disabled={disabled}
                        layout={fieldLayout}
                        label="ตัวอักษร"
                        name="ribbon.color"
                        alpha={false}
                        value={select('ribbon.color')}
                        onChange={onChange}
                    />
                </Item>
            </Group>
        </Card>
    )
}

export default Component